import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { PublicInvoiceCheckStateType } from '@/types/invoiceVaultTypes';
import { SubmitRecipientProfilePayloadType } from '@/api/v1/recipient-requests/submitRecipientProfileApi';

export const openInvoiceCheckApi = (token: string): Promise<ApiResponseType<PublicInvoiceCheckStateType>> =>
  apiService.GET(`/invoice-checks/${token}/`);
export const answerInvoiceCheckApi = (
  token: string,
  answer: 'yes' | 'no'
): Promise<ApiResponseType<PublicInvoiceCheckStateType>> =>
  apiService.POST(`/invoice-checks/${token}/answer/`, { answer });
export const submitInvoiceCheckApi = (
  token: string,
  payload: SubmitRecipientProfilePayloadType
): Promise<ApiResponseType<PublicInvoiceCheckStateType & { result: 'match' | 'mismatch'; organization: string }>> =>
  apiService.POST(`/invoice-checks/${token}/submit/`, payload);
